import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './par-school-year.reducer';
import { IParSchoolYear } from 'app/shared/model/par-school-year.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParSchoolYear = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const parSchoolYearList = useAppSelector(state => state.parSchoolYear.entities);
  const loading = useAppSelector(state => state.parSchoolYear.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="par-school-year-heading" data-cy="ParSchoolYearHeading">
        <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.home.title">Par School Years</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.home.createLabel">Create new Par School Year</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {parSchoolYearList && parSchoolYearList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {parSchoolYearList.map((parSchoolYear, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${parSchoolYear.id}`} color="link" size="sm">
                      {parSchoolYear.id}
                    </Button>
                  </td>
                  <td>{parSchoolYear.code}</td>
                  <td>{parSchoolYear.name}</td>
                  <td>{parSchoolYear.nameAr}</td>
                  <td>{parSchoolYear.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${parSchoolYear.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${parSchoolYear.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${parSchoolYear.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${parSchoolYear.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.home.notFound">No Par School Years found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ParSchoolYear;
